import {DEFAULT_REQUEST_TIMEOUT_MS} from '../../constants/request';

import type {
  RequestTimeoutSignalOptions,
  RequestTimeoutSignalResult,
} from './types';

/**
 * Creates a composite `AbortSignal` that fires on whichever comes first:
 * the configured timeout (default 15 s) or the caller's upstream signal.
 *
 * Uses native `AbortSignal.timeout()` so timeout aborts throw `TimeoutError`
 * (distinguishable from user-initiated `AbortError`) and `AbortSignal.any()`
 * to merge the upstream signal without manual listener wiring.
 */
export const createRequestTimeoutSignal = ({
  upstreamSignal,
  timeoutMs = DEFAULT_REQUEST_TIMEOUT_MS,
}: RequestTimeoutSignalOptions): RequestTimeoutSignalResult => {
  const timeoutSignal = AbortSignal.timeout(timeoutMs);

  const signal: AbortSignal =
    upstreamSignal instanceof AbortSignal
      ? AbortSignal.any([timeoutSignal, upstreamSignal])
      : timeoutSignal;

  return {signal};
};
